import Vue from 'vue'
import Vuex from 'vuex'
import { _getUserInfo, _setUserInfo, _removeUserInfo, _getToken, _setToken, _removeToken } from './localStorage'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    userInfo:_getUserInfo(),
    site:{
      city:'广州',
      lng:'113.67705',
      lat:'23.380954',
    },
    product:null,
    token:_getToken()
  },
  getters: {
    getUserInfo: state => {
      return state.userInfo
    },
    getCity: state => {
      return state.site.city.split('省')[0].split('市')[0].split('区')[0]
    },
    getLngAndLat: state => {
      return {
        lng : state.site.lng,
        lat : state.site.lat
      }
    },
    getUserId: state => {
      if(state.userInfo===null)
        return 0
      else 
        return state.userInfo.userId
    },
    getProduct: state => {
      return state.product
    },
  },
  mutations: {
    setUserInfo(state,{userMsg,accessToken,accessOutTime,refreshToken,refreshOutTime,loginTime}) {
      state.userInfo = userMsg
      state.token = {
        accessToken:accessToken,
        accessOutTime:accessOutTime,
        refreshToken:refreshToken,
        refreshOutTime:refreshOutTime,
        loginTime:loginTime
      }
      _setUserInfo(userMsg)
      _setToken(accessToken,accessOutTime,refreshToken,refreshOutTime,loginTime)
    },
    setPhone(state,phone){
      state.phone = phone
    },
    setSite(state,site){
      state.site = site
    },
    setProduct(state,product){
      state.product = product
    },
    removeUserInfo(state){
      state.userInfo = null
      state.accessToken = null
      state.accessOutTime = null
      state.refreshToken = null
      state.refreshOutTime = null
      state.token = {}
    },
    exitRoom(state){
      state.room = null
      state.product=null
      state.anchorInfo = null
    }
  },
  actions: {
    logout({ commit }){
      commit('exitRoom')
      commit('removeUserInfo')
      commit('')
      _removeUserInfo()
      _removeToken()
    }
  }
})

export default store
